import { BoxProps, Panel } from '@hover/blueprint';
import React from 'react';

import { AnimatedContainer } from './components/AnimatedContainer';

type SlideUpCardProps = {
  closeMenu?: () => void;
  disabled?: boolean;
} & BoxProps;

const SlideUpCard = ({
  children,
  closeMenu,
  disabled,
  ...props
}: SlideUpCardProps) => (
  <AnimatedContainer closeMenu={closeMenu} disabled={disabled}>
    <Panel
      borderRadius="12px 12px 0 0"
      bottom="0"
      height="100%"
      overflowY="auto"
      paddingTop={400}
      paddingX={400}
      width="100%"
      {...props}
    >
      {children}
    </Panel>
  </AnimatedContainer>
);

export { SlideUpCard };
